module.exports = __webpack_public_path__ + "static/duerer-801828e64c6833321615ce5867c50f8c.png";